import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';

export type SectionTitleProps = {
  className?: string;
  children?: React.ReactNode;
  en: string;
  as?: keyof HTMLElementTagNameMap;
  subText?: React.ReactNode;
};

export const SectionTitle: React.FC<SectionTitleProps> = ({
  className,
  children,
  en,
  as: Tag = 'h2',
  subText,
}) => {
  return (
    <div className={className}>
      <p
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 9px;
          margin-bottom: 16px;

          @media ${getScreen('pc')} {
            gap: 12px;
            margin-bottom: 24px;
          }

          &::after {
            content: '';
            display: block;
            background-color: #00b3a7;
            height: 1px;
            width: 52px;

            @media ${getScreen('pc')} {
              width: 76px;
            }
          }
        `}
      >
        <span
          css={css`
            font: normal normal bold 14px/18px 'din-2014-narrow', sans-serif;
            letter-spacing: 1.8px;
            color: #00b3a7;

            @media ${getScreen('pc')} {
              font: normal normal bold 14px/18px 'din-2014-narrow', sans-serif;
            }
          `}
        >
          {en}
        </span>
      </p>
      <Tag
        css={css`
          letter-spacing: var(--unnamed-character-spacing-0-8);
          text-align: center;
          font: normal normal bold 20px/29px 'Noto Sans JP';
          letter-spacing: 0.8px;
          color: #444557;

          @media ${getScreen('pc')} {
            font: normal normal bold 32px/46px 'Noto Sans JP';
            letter-spacing: 1.28px;
          }

          strong {
            color: #00b3a7;
            font-weight: inherit;
          }
        `}
      >
        {children}
      </Tag>
      {subText && (
        <div
          css={css`
            margin-top: 32px;
            text-align: center;
            font: normal normal normal 14px/22px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.11px;
            color: #444557;
            word-break: keep-all;

            @media ${getScreen('pc')} {
              font: normal normal normal 16px/26px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.51px;
            }

            span {
              color: #00b3a7;
            }
          `}
        >
          {subText}
        </div>
      )}
    </div>
  );
};
